import React from 'react';
import { Grid, InputAdornment } from '@mui/material';
import { Field } from 'formik';
import { TextField } from 'components/FormFields';
import i18n from 'i18n-js';
import PropTypes from 'prop-types';

const containerSx = {
  maxWidth: '35rem',
  margin: 'auto',
};

const priceDescriptionSx = {
  fontSize: '0.75rem',
  color: (theme) => theme.palette.text.secondary,
};

const BasicInformationInputs = ({ errors }) => (
  <Grid item size={12} sx={containerSx}>
    <Grid container spacing={2}>
      <Grid item size={{ xs: 12, md: 12 }}>
        <Field
          margin="none"
          label={i18n.t('common.name')}
          name="name"
          asyncErrors={errors.name}
          component={TextField}
          data-cy="credit-type-name-input"
        />
      </Grid>
      <Grid item size={{ xs: 12, md: 12 }}>
        <Field
          margin="none"
          label={i18n.t('common.description')}
          name="description"
          asyncErrors={errors.description}
          component={TextField}
          required={false}
          data-cy="credit-type-description-input"
        />
      </Grid>
      <Grid item size={{ xs: 12, md: 6 }}>
        <Field
          min={1}
          step="any"
          type="number"
          margin="none"
          format="price"
          label={i18n.t('common.default_price')}
          name="default_unit_price"
          asyncErrors={errors.default_unit_price}
          component={TextField}
          startAdornment={
            <InputAdornment position="start" sx={{ marginRight: -1 }}>
              $
            </InputAdornment>
          }
          data-cy="credit-type-default_unit_price-input"
        />
        <span style={{ ...priceDescriptionSx }}>
          {i18n.t('credit_types.default_price_description')}
        </span>
      </Grid>
    </Grid>
  </Grid>
);

BasicInformationInputs.propTypes = {
  errors: PropTypes.object,
};

BasicInformationInputs.defaultProps = {
  errors: {},
};

export { BasicInformationInputs };
